import { Fragment } from "react";
import { Toaster } from "react-hot-toast";

const ToastNotification = () => {
    return (
        <Fragment>
            <Toaster
                position="top-center"
                toastOptions={{
                    className: "!shadow-sm phone:leading-[23.8px] font-medium desktop:text-[16px] tablet:text-[16px] phone:text-[14px] !shadow-notification",
                    duration: 5000,
                    style: {
                        background: "#F5F5FF",
                        color: "#01112D",
                        maxWidth: "500px",
                        borderRadius: "8px",
                        padding: "16px",
                        gap: "16px"
                    },
                    success: {
                        duration: 5000,
                        theme: {
                            primary: "#645AFF"
                        },
                        iconTheme: {
                            primary: "#645AFF"
                        }
                    },
                    error: {
                        duration: 5000,
                        theme: {
                            primary: "#FE8A8C"
                        }
                    }
                }} />
        </Fragment>
    );
};

export default ToastNotification;